import { createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { notify } from 'components/Common/Toast';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';
import { ParishMemberDetailState } from 'types/community';
import { getDefaultCompanyId } from 'utils/helpers';

const initialState: ParishMemberDetailState = {
    details: {},
    loading: false,
    error: null,
};
interface FetchParishMemberDetails {
    uuid: string;
}
interface UpdateParishionerDetailsPayload {
    username: string;
    payload: any;
}
export const fetchParishMemberDetails = createAsyncThunkWrapper<any, FetchParishMemberDetails>(
    'parishMemberDetails/fetchParishMemberDetails',
    async ({ uuid }: FetchParishMemberDetails, { getState }) => {
        const state: any = getState();
        const defaultCompanyId = getDefaultCompanyId(state);
        if (!defaultCompanyId) {
            return;
        }

        const response: any = await client.get('/customer/getCustomerInfo', {
            headers: {
                uuid,
                companyId: defaultCompanyId,
            },
        });
        return { user: response?.user || {} };
    }
);

export const updateParishionerDetails = createAsyncThunkWrapper<any, UpdateParishionerDetailsPayload>(
    'parishMemberDetails/updateParishionerId',
    async ({ username, payload }: UpdateParishionerDetailsPayload) => {
        const response: any = await client.put(`/userAdditionalInfo/${username}`, payload);
        if (response?.code === 200) {
            notify('Parishioner details updated successfully', 'success');
        }
        return response;
    }
);

const parishMemberDetailsSlice = createSlice({
    name: 'parishMemberDetails',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchParishMemberDetails.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchParishMemberDetails.fulfilled, (state, action) => {
            state.loading = false;
            if (!action?.payload) return;
            const { user } = action?.payload || {};
            state.details = user;
        });
        builder.addCase(fetchParishMemberDetails.rejected, (state) => {
            state.loading = false;
        });
    },
});

export default parishMemberDetailsSlice.reducer;
